import sc from 'styled-components';
import {UnifonTheme} from '@phonectas/unifon-ui-kit';

export const StyledAccordionContainer = sc.div`
    width: 100%;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    position: relative;
    outline: none;
    box-sizing: border-box;
`;

export const StyledAccordionSection = sc.div<{theme: UnifonTheme, $expanded?: boolean}>`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-shadow:
        0px 2px 1px -1px rgba(0, 0, 0, 0.2), 
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 
        0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: none;
    outline: none;
    overflow: hidden;
    background: ${({theme}) => theme.palette.white};
`;

export const StyledAccordion = sc.div<{theme: UnifonTheme, $active: boolean}>`
    background-color: ${({theme, $active}) => $active ? '#efefefff' : theme.palette.white};
    cursor: pointer;
    padding: ${({theme}) => theme.spacing(2, 3)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: ${({$active}) => $active ? '4px 4px 0 0' : '4px'};
    border: none;
    outline: none;
    transition: background-color 0.6s ease;

    &:active {
        background-color: #efefefff;
    }
    &:hover {
        background-color: #efefefff;
    }
`;

export const StyledAccordionContent = sc.div<{$expanded: boolean}>`
    padding: ${props => (props.$expanded ? '10px 18px' : '0 18px')};
    max-height: ${props => (props.$expanded ? '1000px' : '0')};
    transition: max-height 0.3s ease, padding 0.3s ease;
    border-radius: 4px;
    border: none;
    outline: none;
`;
